import moment from 'moment';
import {
  addIndex,
  always,
  and,
  complement,
  compose,
  cond,
  defaultTo,
  dissoc,
  either,
  equals,
  filter,
  ifElse,
  is,
  isEmpty,
  isNil,
  length,
  map,
  reduce,
  replace,
  toUpper,
  trim
} from 'ramda';

export const isNilOrEmpty = compose(either(isNil, isEmpty), dissoc('__typename'));
export const isNotNilOrEmpty = complement(isNilOrEmpty);
export const mapIndexed = addIndex(map);
export const reduceIndexed = addIndex(reduce);

export const filterIndexed = addIndex(filter);
export const isNotNil = complement(isNil);
export const isNumber = is(Number);
export const trimNumber = compose(trim, replace(/\s/g, '')) || '';
export const trimAndUpper = compose(toUpper, trim, replace(/\s/g, ''), defaultTo(''));
export const pipeAsync =
  (...fns) =>
    (x) =>
      fns.reduce((p, f) => p.then((v) => Promise.resolve(f(v))), Promise.resolve(x));
export const lengthEq = (expectedLength, list) => equals(length(list), expectedLength);

export const birthdateFromAge = (age, startDate, calculationMode, startOfDayMonthYear) =>
  cond([
    [always(and(equals(age, -1), equals(startOfDayMonthYear, true))), always(0)],
    [always(and(equals(age, -1), equals(startOfDayMonthYear, false))), always(moment())],
    [
      always(and(equals('Date à date', calculationMode), equals(startOfDayMonthYear, true))),
      always(moment(startDate).startOf('day').subtract(age, 'years'))
    ],
    [
      always(and(equals('Date à date', calculationMode), equals(startOfDayMonthYear, false))),
      always(moment(startDate).endOf('day').subtract(age, 'years'))
    ],
    [
      always(and(equals('Millésime', calculationMode), equals(startOfDayMonthYear, true))),
      always(moment(startDate).startOf('year').startOf('day').subtract(age, 'years'))
    ],
    [
      always(and(equals('Millésime', calculationMode), equals(startOfDayMonthYear, false))),
      always(moment(startDate).endOf('year').endOf('day').subtract(age, 'years'))
    ]
  ])(calculationMode);

export const dateEligibility = (birthdate, min, max) => {
  const parsed = parseDate(birthdate);
  return ifElse(
    () =>
      parsed.isValid() &&
      (isNil(min) || parsed.isSameOrBefore(min)) &&
      (isNil(max) || parsed.isSameOrAfter(max)),
    always({
      label: 'Eligible',
      variant: 'success'
    }),
    always({
      label: 'Non éligible',
      variant: 'error'
    })
  )(parsed.toDate());
};

export const formatSSNumberKey = (number) => {
  if (number) {
    return `${number[0]} ${number.substring(1, 3)} ${number.substring(3, 5)} ${number.substring(5, 7)} ${number.substring(7, 10)} ${number.substring(10, 13)} ${number.substring(13, 15)} ${number.substring(15, 17)}`;
  }
};

export const parseDate = (date) => {
  if (moment.isMoment(date)) return date;

  if (date instanceof Date) return moment(date);

  if (typeof date === 'string') {
    const frFormat = moment(date, 'DD/MM/YYYY', true);
    if (frFormat.isValid()) return frFormat;
    return moment(date, moment.ISO_8601, true);
  }

  return moment.invalid();
};

export const frToIso = (value) => moment(parseDate(value)).toISOString();
